"use client";

import posthog from "posthog-js";
import { BUSINESS } from "@/lib/constants";

interface CollaborateButtonProps {
  className?: string;
  children: React.ReactNode;
}

export function CollaborateButton({ className, children }: CollaborateButtonProps) {
  return (
    <a
      href={BUSINESS.collaborateFormUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={() => posthog.capture("collaboration_inquiry_clicked")}
    >
      {children}
    </a>
  );
}
